import { redirect } from "react-router-dom";
import { auth } from "../firebaseConfig";
import store from "../store";
import { userActions } from "../store/user-slice";
import { fetchMe } from "../utils/http/users";
import { sleep } from "../utils/system";

export async function checkRoutePermissionLoader(allowedRoles: string[]) {
  // This will give Firebase one second to get things in order. We don't care there's a small waiting delay, since we expect
  // users to be logged in on these pages anyway. This will only apply on hard page refreshes. In case the user already logged
  // in and is just navigating React links, he will not experience a delay at all.
  for (let i = 0; i < 10; i++) {
    await sleep(100);
    const idTokenResult = await auth?.currentUser?.getIdTokenResult();
    if (idTokenResult) {
      const currentState = store.getState().user;
      const tokenEmail = idTokenResult.claims.email as string;

      // Only fetch user info if email has changed or if we don't have user data yet
      if (!currentState.email || currentState.email !== tokenEmail) {
        try {
          // Fetch full user info from backend including roles
          const userInfo = await fetchMe({ token: idTokenResult.token });
          store.dispatch(
            userActions.setUser({
              email: userInfo.email,
              displayName: userInfo.display_name,
              roles: userInfo.roles,
            })
          );
        } catch (error) {
          console.error("Error fetching user info in loader:", error);
          // Fallback to Firebase data if /me endpoint fails
          store.dispatch(
            userActions.setUser({
              email: tokenEmail,
              displayName: idTokenResult.claims.name as string,
              roles: [],
            })
          );
        }
      }
      break;
    }
  }

  // If the user does not have the proper permissions, move him to the homepage
  const userRoles = store.getState().user.roles;
  if (!allowedRoles.some((r) => userRoles?.includes(r))) {
    return redirect("/");
  }

  return null;
}
